/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEventCountryCountResponse
 */
export interface AuditEventCountryCountResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditEventCountryCountResponse
     */
    country?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventCountryCountResponse
     */
    count?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventCountryCountResponse
     */
    failedCount?: any | null;
}

/**
 * Check if a given object implements the AuditEventCountryCountResponse interface.
 */
export function instanceOfAuditEventCountryCountResponse(value: object): value is AuditEventCountryCountResponse {
    return true;
}

export function AuditEventCountryCountResponseFromJSON(json: any): AuditEventCountryCountResponse {
    return AuditEventCountryCountResponseFromJSONTyped(json, false);
}

export function AuditEventCountryCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventCountryCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'] === undefined ? undefined : json['country'] === null ? null : json['country'],
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
        'failedCount': json['failedCount'] === undefined ? undefined : json['failedCount'] === null ? null : json['failedCount'],
    };
}

export function AuditEventCountryCountResponseToJSON(json: any): AuditEventCountryCountResponse {
    return AuditEventCountryCountResponseToJSONTyped(json, false);
}

export function AuditEventCountryCountResponseToJSONTyped(value?: AuditEventCountryCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': value['country'],
        'count': value['count'],
        'failedCount': value['failedCount'],
    };
}

